export default __webpack_public_path__ + "static/media/discord_eternal.cb475fe1.svg";